import { getWidget } from '@uvocore-front/utils';
import './styles.scss';

window.addEventListener('DOMContentLoaded', () => {
  getWidget({
    widgetLink: '/assets/js/ratingWidget.min.js',
    loader: false,
    fn: () => {
      window.ratingWidget({});
    },
  });
});
